import { Component, EventMouse, Node, _decorator } from 'cc';
import { DEV } from 'cc/env';

const { ccclass, property } = _decorator;
const SENSITIVITY_CONSTANT = 0.00001; // multiplier for sensitivity to prevent from being too large

@ccclass('MouseWheelZoom')
export default class MouseWheelZoom extends Component {
    @property({ displayName: DEV && '最大縮放倍率' })
    private readonly maxScaleRatio = 5;

    @property({ displayName: DEV && '最小縮放倍率' })
    private readonly minScaleRatio = 0.2;

    @property({ displayName: DEV && '縮放靈敏度', tooltip: DEV && '數值越大，縮放越靈敏' })
    private readonly sensitivity = 5;

    protected onLoad(): void {
        // handle mouse wheel event for zooming
        const originalScale = this.node.scale.clone();
        let currentScaleRatio = 1;
        this.node.on(Node.EventType.MOUSE_WHEEL, (event: EventMouse) => {
            currentScaleRatio += event.getScrollY() * this.sensitivity * SENSITIVITY_CONSTANT;
            currentScaleRatio = Math.max(this.minScaleRatio, Math.min(this.maxScaleRatio, currentScaleRatio));
            this.node.setScale(originalScale.x * currentScaleRatio, originalScale.y * currentScaleRatio, originalScale.z);
        });
        // reset the scale ratio when the mouse wheel button is clicked
        this.node.on(Node.EventType.MOUSE_UP, (event: EventMouse) => {
            if (event.getButton() === 1) {
                currentScaleRatio = 1;
                this.node.setScale(originalScale);
            }
        });
    }
}
